import { createStore } from '@stencil/store';

import { PageParams } from '../interfaces/interface.analytics';

const initialState: PageParams = {
  category: 'ico-component',
  entry: '',
  isAdmin: false,
  lnxCode: '',
  offerCode: '',
  showIcoQuestionsSection: true,
  utmSource: '',
  dealerName: '',
};

const { on, onChange, state, reset } = createStore(initialState);

export { initialState, on, onChange, state, reset };
export default state;
